import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider, useCurrencyFormatting, useProductFilters } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"
import { currency_symbols, currentCurrency, isDesktop, formatRangeFacetValue } from "../helpers"

export default function RangeFacet({ facet, isSearch }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [active, setActive] = useState(isSelected);
    const { format } = useCurrencyFormatting();
    const { filters, removeAll } = useProductFilters();
    
    const [marks, setMarks] = useState([]);
    const [filtersOfFacet, setFiltersOfFacet] = useState([]);
    useEffect(()=>{
        const updatedFilters = filters.filter(filter => filter.field === facet.field);
        setFiltersOfFacet(updatedFilters);
    }, [filters]);

    useEffect(()=>{
        const range = max - min;
        let step = Math.round(range / 4);
        let firstMark = min;
        let secondMark = min + step;
        let thirdMark = secondMark + step;
        let fourthMark = thirdMark + step;
        let fifthMark = max;
        setMarks([firstMark, secondMark, thirdMark, fourthMark, fifthMark]);

    }, [min, max])
    
    useEffect(()=>{
        if(active && !isDesktop && isSearch){
            setActive(false);
        }
    }, [])

    useEffect(()=>{
        if(!active && isDesktop){
            setActive(true);
        }
    }, [])

    return (
        <li class={`ns-sidebar-dropdown ns-range-facet ${active ? "ns-active" : ""}`}>
            <span
                class="ns-anchor ns-d-inline-flex ns-relative ns-w-100 ns-border-box"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="ns-font-1 ns-facet-name">{facet.name}</span>
                
                {isSearch && !isDesktop ? (
                    <svg class="nosto__filter-option-icon" xmlns="http://www.w3.org/2000/svg" width="7" height="12" role="img" aria-label={`Filter by: ${facet?.name}`} viewBox="0 0 7 12" fill="#222">
                        <path class="nosto__filter-option-path" d="M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z"></path>
                    </svg>
                ) : (
                    <>
                        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                            </path>
                        </svg>
                        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                            </path>
                        </svg>
                    </>
                )}
                
                {isSearch && isDesktop && isSelected ?(
                    <span class="ns-clear-specific-facet ns-font-1" onClick={() => updateRange([min, max])}>Clear</span>
                ) : ''}
            </span>
            {isSearch && !isDesktop && filtersOfFacet?.length > 0 ? (
                    <div class="nosto__filter-option-mobile-items-selected">{
                        formatRangeFacetValue(filtersOfFacet[0]?.value)
                    }</div>
            ) : ''}
            <div class="ns-sidebar-submenu ns-d-none">
                <span
                    class="ns-anchor ns-d-inline-flex ns-relative ns-w-100 ns-border-box"
                    onClick={() => {
                        setActive(!active)
                    }}
                >
                    {isSearch ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none" role="img" aria-label="Close">
                            <path d="M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z" fill="#222222"></path>
                        </svg>
                    ) : (
                        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                            </path>
                        </svg>
                    )}
                    <span class="ns-font-1 ns-facet-name">{facet.name}</span>
                    <div class="ns-d-block">
                        {isSearch && !isDesktop && filtersOfFacet?.length > 0 ?(
                            <span class="ns-clear-specific-facet ns-font-1" onClick={(e)=>{
                                e.stopPropagation();
                                updateRange([min, max]);
                            }}>Clear</span>
                        ) : ''}
                    </div>
                </span>
                {!isSearch && <div class="facets__header-vertical">
                    <span class="facets__selected">The highest price is {format(max)}</span>
                </div>}
                <div class="ns-d-flex ns-justify-content-between ns-font-4 ns-range-inputs-wrapper">
                    <span class="field-currency">{currency_symbols[currentCurrency]}</span>
                    {/* class="ns-col-6 flex-shrink-1 ns-mr-2" */}
                    <div class="field">
                        {isSearch && <span class="nosto__filter-option-range-slider-unit ns-font-1">{currency_symbols[currentCurrency]}</span>}
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                        <label class="field__label" for={`ns-${facet?.id}-min`}>From</label>
                    </div>
                    {/* class="ns-col-6 flex-shrink-1" */}
                    {!isDesktop && <span class="field-currency">{currency_symbols[currentCurrency]}</span>}
                    {isSearch && <div class="nosto__filter-option-range-slider-input-split">-</div>}
                    <div class="field">
                        {/* <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label> */}
                        {isSearch && <span class="nosto__filter-option-range-slider-unit ns-font-1">{currency_symbols[currentCurrency]}</span>}
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                        <label class="field__label" for={`ns-${facet?.id}-max`}>To</label>
                    </div>
                </div>
                {isSearch && (
                    <div class="ns-relative">
                        <RangeSlider id={facet.id} />
                        <div class="ns-d-flex ns-justify-content-between ns-inter-marks-container">
                        {marks && marks?.length > 0 ? marks.map((mark) => {
                                return (
                                    <span class="ns-inter-mark">{mark}</span>
                                )
                            }) : ''}
                        </div>
                    </div>
                )}
            </div>
        </li>
    )
}
